import styled from 'styled-components';

const Div = styled.div``;

export default Div;
